module.exports = __webpack_public_path__ + "static/media/arrow-right.558958ad.svg";